import { render } from "./VueRecordAudio.vue?vue&type=template&id=00bea7ba&lang=html"
import script from "./VueRecordAudio.vue?vue&type=script&lang=js"
export * from "./VueRecordAudio.vue?vue&type=script&lang=js"

import "./VueRecordAudio.vue?vue&type=style&index=0&id=00bea7ba&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__